import { httpsCallable } from "firebase/functions";
import { functions } from "../../../firebase";

const getReportCombined = httpsCallable<any, any>(functions, "fetchRawReportCombined");
const getReportDownloadLinkCombined = httpsCallable<any, any>(functions, "fetchAndStoreReportCombined");

export const fetchReportDownloadLinkCombined = async (
  reportId: string,
  startDate: string | Date,
  endDate: string | Date,
  renderType: string,
  reportName: string,
  documentId: string | null,
  companyId: string,
  uid: string,
  addlFieldMap: Record<string, any> | null = null,
  reportConfigCollection = "reportSetUp"
): Promise<any> => {
  const result = await getReportDownloadLinkCombined({
    reportId: reportId,
    reportName: reportName,
    startDate: startDate,
    endDate: endDate,
    renderType,
    documentId,
    companyId,
    uid,
    addlFieldMap,
    reportConfigCollection,
  });

  return result.data;
};

export const fetchAndDownloadReportCombined = async (
  reportId: string,
  startDate: string | Date | null | undefined,
  endDate: string | Date | null | undefined,
  renderType: string,
  reportName: string,
  documentId: string,
  reportConfigCollection = "reportSetUp"
): Promise<any> => {
  const result = await getReportCombined({
    reportId: reportId,
    reportName: reportName,
    startDate: startDate,
    endDate: endDate,
    renderType,
    documentId,
    reportConfigCollection,
  });

  return result.data;
};
